<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      梅景站<br>
站点介绍<br>
梅景站位于北环大道至下梅林一街之间的梅林路下，车站沿梅林路南北向布置，车站周边社区发展较为成熟，分布有碧云天小区、尚书苑、梅林苑绿景虹湾等成熟社区及福田区农贸产品批发市场。车站采用红色基调，文化墙以五颜六色的色板组成一朵朵梅花，该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:04	23:29	9号线	3分50秒	5分55秒<br>
文锦	06:30	23:40	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:03	23:29	9号线	4分25秒	5分55秒<br>
文锦	06:30	23:40	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:06	00:29	9号线	4分钟	5分55秒<br>
文锦	06:29	00:40	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A1出入口:<br>
绿景虹湾、北环大道北侧（东）、梅林路东侧<br><br>
A2出入口:<br>
深圳石油大厦、北环大道南侧、紫薇阁、中审大厦、开元大厦、景田路、广州中医药大学深圳医院<br><br>
C出入口:<br>
梅林路西侧（北）、下梅林一街、尚书苑、福田农批市场<br><br>
D出入口:<br>
北环大道北侧（西）、梅林路西侧（南）、碧云天、梅林苑<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 福田农批市场<br>
7路、12路、218路、216路、M312路、M390路、M441路、334路<br><br>
A2出入口:<br>
公交站名： 深圳石油大厦<br>
44路、58路、67路、201路、334路、E18路、M203路、M240路、M358路、M364路、M398路、M460路、高峰专线22、高峰专线31路、M526路、高快巴士28、高快巴士29、高峰专线34<br><br>
A2出入口:<br>
公交站名： 紫薇阁总站<br>
11路、21路、B689路<br><br>
A2出入口:<br>
公交站名： 广中医深圳医院<br>
58路、67路、201路、334路、高峰专线21、M203路、M222路、M240路、M358路、M364路、M398路、M460路、44路、M526、高峰专线22、高峰专线31、高快巴士28、高快巴士29、高峰专线34<br><br>
C出入口:<br>
公交站名： 福田农批市场<br>
12路、102路、201路、216路、334路、B666路、B928、M312路、M441路、M460路<br><br>
C出入口:<br>
公交站名： 梅林一村总站<br>
111路、M499<br><br>
D出入口:<br>
公交站名： 广中医深圳医院<br>
58路、67路、201路、334路、B928、E18路、高峰专线21、M203路、M222路、M240路、M358路、M364路、M460路、44路、高峰专线22、M398、M526、高快巴士28、高快巴士29、高峰专线34、高峰专线31路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>